import React from 'react';
import Icon from '../atoms/Icon';

function ThreeX(props: any, ref: React.Ref<any>) {
  return (
    <Icon {...props} ref={ref}>
      <path d="M16 30.667c8.1 0 14.667-6.567 14.667-14.667S24.1 1.333 16 1.333 1.333 7.9 1.333 16 7.9 30.667 16 30.667" fill="#f47321"/>
      <path d="M29.333 16c0-7.364-5.97-13.333-13.333-13.333S2.667 8.637 2.667 16 8.637 29.333 16 29.333 29.333 23.363 29.333 16M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0s16 7.163 16 16" fill="#000"/>
      <path d="M9.861 21.525c-1.952 0-3.424-.752-4.208-1.712l1.2-1.52c.72.768 1.888 1.216 2.928 1.216 1.296 0 2.016-.56 2.016-1.36 0-.848-.656-1.232-2.144-1.232-.448 0-1.168.016-1.328.032v-2.048c.192.016.928.016 1.328.016 1.184 0 1.984-.352 1.984-1.136 0-.848-.88-1.264-1.984-1.264-1.04 0-1.968.384-2.72 1.104l-1.136-1.424c.864-.976 2.208-1.696 4.08-1.696 2.496 0 4.032 1.12 4.032 2.896 0 1.344-1.152 2.224-2.336 2.432 1.088.112 2.496.96 2.496 2.56 0 1.84-1.648 3.136-4.208 3.136m15.599-.192h-2.72l-2.672-3.904-2.688 3.904h-2.704l3.872-5.472-3.632-5.2h2.704l2.448 3.648 2.416-3.648h2.736l-3.632 5.184z" fill="#fff"/>
    </Icon>
  );
}

export default React.forwardRef(ThreeX);